import { useState } from 'react';
import axios from 'axios';
import './Contact.css';

const API = process.env.REACT_APP_API_URL;

const INITIAL = { name: '', email: '', company: '', segment: '', message: '' };

const CONTACT_INFO = [
  { label: 'gerenciar@gerenciarsc.com.br' },
  { label: '+55 31 985-558-887' },
  { label: 'Rua Ituiutaba, 340, Belo Horizonte, Minas Gerais' },
];

const Contact = () => {
  const [form, setForm] = useState(INITIAL);
  const [status, setStatus] = useState('idle');

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus('validation');
      return;
    }
    setStatus('sending');
    try {
      await axios.post(`${API}/contact`, {
        name: form.name,
        email: form.email,
        company: form.company,
        segment: form.segment,
        message: form.message,
      });
      setStatus('success');
      setForm(INITIAL);
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="contact" id="contato">

      {/* Left */}
      <div className="contact__left">
        <h2 className="contact__heading">
          Comece
          <em>agora.</em>
        </h2>
        <p className="contact__desc">
          Fale com um dos nossos especialistas e descubra como a Gerenciar
          pode transformar a gestão da sua empresa.
        </p>
        <ul className="contact__info">
          {CONTACT_INFO.map(({ label }) => (
            <li className="contact__info-item" key={label}>
              <span className="contact__info-dot" aria-hidden="true" />
              <span className="contact__info-text">{label}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Right: form */}
      <div className="contact__right">
        <form className="contact__form" onSubmit={handleSubmit} noValidate>

          <div className="contact__row">
            <div className="contact__field">
              <label className="contact__label" htmlFor="name">Nome</label>
              <input
                id="name" name="name" type="text"
                className="contact__input"
                placeholder="Nome completo"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="contact__field">
              <label className="contact__label" htmlFor="email">E-mail</label>
              <input
                id="email" name="email" type="email"
                className="contact__input"
                placeholder="email@empresa.com"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="contact__row">
            <div className="contact__field">
              <label className="contact__label" htmlFor="company">Empresa</label>
              <input
                id="company" name="company" type="text"
                className="contact__input"
                placeholder="Nome da empresa"
                value={form.company}
                onChange={handleChange}
              />
            </div>
            <div className="contact__field">
              <label className="contact__label" htmlFor="segment">Segmento</label>
              <input
                id="segment" name="segment" type="text"
                className="contact__input"
                placeholder="Saúde, Varejo..."
                value={form.segment}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="contact__row">
            <div className="contact__field contact__field--full">
              <label className="contact__label" htmlFor="message">Mensagem</label>
              <input
                id="message" name="message" type="text"
                className="contact__input"
                placeholder="Como podemos ajudar?"
                value={form.message}
                onChange={handleChange}
              />
            </div>
          </div>

          {status === 'validation' && (
            <p className="contact__feedback contact__feedback--error">
              Preencha os campos obrigatórios: Nome, E-mail e Mensagem.
            </p>
          )}
          {status === 'success' && (
            <p className="contact__feedback contact__feedback--success">
              Mensagem enviada! Em breve entraremos em contato.
            </p>
          )}
          {status === 'error' && (
            <p className="contact__feedback contact__feedback--error">
              Erro ao enviar. Tente novamente ou entre em contato diretamente.
            </p>
          )}

          <button type="submit" className="contact__submit" disabled={status === 'sending'}>
            {status === 'sending' ? 'Enviando...' : 'Enviar mensagem'}
          </button>

        </form>
      </div>

    </section>
  );
};

export default Contact;